export { HuntPageComponent } from './hunt-page/hunt-page.component';



// WEBPACK FOOTER //
// ./src/app/hunt/pages/index.ts